import { React, css } from '../..';

const SubSection = ({ name, content }) => {
    return (
        <div className={css['summary-header-subtitle']}>
            <span>{name}</span>
            {content}
        </div>
    );
};

export default SubSection;
